import { isEventLive } from '@/utils/event-time';
import { formatMatchupString, formatScoredMatchupString } from '@/utils/sport-utils';

import { useSbkBetSlipStore } from './use-sbk-betslip-store';

/**
 * Returns formatted matchup string for an event.
 * Live events include scores: "UTA 3 @ MIA 6"
 * Pre-match events show team codes: "UTA @ MIA"
 * Format varies by sport (e.g., Soccer shows "Home vs Away" with alias names)
 */
export const useEventMatchup = (eventId: string) => {
    return useSbkBetSlipStore(state => {
        const event = state.events[eventId];
        if (!event) {
            return undefined;
        }

        const sportName = event.sport?.name ?? '';

        if (isEventLive(event)) {
            return formatScoredMatchupString(
                event.home_team?.short_code ?? '',
                event.away_team?.short_code ?? '',
                event.event_details?.home_score,
                event.event_details?.away_score,
                sportName
            );
        }

        return formatMatchupString(event.home_team.short_code, event.away_team.short_code, sportName);
    });
};
